import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkersQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectEnvironment: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const {
    data: workers,
    isLoading,
    refetch,
  } = useWorkersQuery(String(pathParameters.workspace_id));

  const workerItems = useMemo(
    () =>
      workers
        ? workers.map(({ id, name }) => ({
            label: name,
            value: id,
          }))
        : [],
    [workers],
  );

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ApiHelperSelectInput
      label={t('workerApi.chooseWorker')}
      items={workerItems}
      onChange={(value) => setValue('worker_id', value)}
      loading={isLoading}
      value={value}
      noItemsFound={t('workerApi.noWorkers')}
      {...props}
    />
  );
};
